import {AxiosResponse} from 'axios';
import {ProductFilter} from 'hooks/useProductList';
import {omit} from 'lodash';
import {PaginatedResponse} from 'types';
import {ApiClient} from './api-client';
import {Product} from 'types';

export type UpdateProductDto = Omit<Partial<Product>, 'image' | 'id'> & {
  image?: File;
};

export class ProductService extends ApiClient {
  async getProducts(
    filter: ProductFilter
  ): Promise<AxiosResponse<PaginatedResponse<Product>>> {
    return this.get(`/products/`, {
      ...omit(filter, 'page'),
      offset: (filter.page || 0) * 20,
    });
  }

  async updateProduct(id: number, dto: UpdateProductDto) {
    const formData = new FormData();
    Object.keys(omit(dto, 'image')).forEach((key) => {
      const objectKey = key as keyof UpdateProductDto;
      const objectValue = dto[objectKey];
      if (typeof objectValue === 'undefined') {
        formData.append(key, '');
      } else {
        formData.append(key, objectValue);
      }
    });
    if (dto.image) {
      formData.append('image.file', dto.image);
    }
    return this.put(`/products/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}
